import * as PIXI from "pixi.js";
import ServiceLocator from "../../ServiceLocator";
import { Profile } from "../../lib/game_snacks/IUser";
import Utils from "../../Utils";
import GSAvatarLoader from "../../lib/GSAvatarLoader";


export default class PlayerSlot extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _portrait: PIXI.Sprite = null;
    private _username: PIXI.Text = null;

    private _profile: Profile = null;

    private _isEmpty: boolean = null;

    // #endregion //


    public get profile(): Profile { return this._profile; }
    public get isEmpty(): boolean { return this._isEmpty; }


    // #region Methods //

    // public:

    public constructor() 
    { 
        super(); 

        this._isEmpty = true;

        this._portrait = new PIXI.Sprite( ServiceLocator.resources.avatar_unknown.texture );
        this._portrait.scale.set( 100/this._portrait.texture.width );
        this._portrait.anchor.set( 0.5 );
        this.addChild( this._portrait );            

        this._username = new PIXI.Text( "", { fontFamily: "asap_bold", fontSize: 40, fill: 0x474747, stroke: 0xffffff, strokeThickness: 6, lineJoin: "round" } );
        this._username.anchor.set( 0.5, 0 );
        this._username.y += 57;
        this.addChild( this._username );    
    }

    public setPlayer( profile: Profile ): void
    {
        this._isEmpty = false;

        this._profile = profile;
    
        GSAvatarLoader.i.load( 
            profile.avatar.src, 
            ( texture: PIXI.Texture ) => {
                // TODO: The screen containing the player slot might be destroyed, but the callback is still active!!!
                try 
                {
                    this._portrait.texture = texture;
                    this._portrait.scale.set( 100/this._portrait.texture.width ); 
                } 
                catch( ex ) {}
            } );
        this._username.text = profile.username.prefix;
        this._username.scale.set( 1 );
        Utils.fitTextToWidth( this._username, 300 );
    }

    public isPlayer( profile: Profile ): boolean
    {
        return this._profile.uid == profile.uid;
    }

    public empty( profile: Profile = null ): void
    {
        this._portrait.texture = ServiceLocator.resources.avatar_unknown.texture;
        this._portrait.scale.set( 100/this._portrait.texture.width );
        this._username.text = "";

        this._profile = profile;

        this._isEmpty = true;
    }

    // #endregion //
}